module.exports = __webpack_public_path__ + "assets/img/f7b5af0a93c0b8995be078fb8dca8ba5.png";